<ul class="file-download-one-action-list">
    <li class="" *ngFor="let file of files; index as i">
        <core-file-download-one-action-list-item
            [file]="file"
            [actionText]="actionText"
            [actionStyle]="actionStyle"
            [bubble]="bubbles && getBubbleText(i)!=''"
            [bubbleNumber]="getBubbleText(i)"
            (actionClick)="onActionClick(file)"
            (bubbleClick)="onBubbleClick(file)"
        >
        </core-file-download-one-action-list-item>
    </li>
</ul>
